<template>
  <page-outline :title="$t('contacts.contact_details')">
    <template slot="pageContent">
      <b-row class="m-0 pb-3" no-gutters>
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <form-accordion :title="$t('common.contact_ids')" class="form-accordion-subtitle" :isTitleUpperCase="false">
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline" v-if="typeContact === '1'">
            <input v-model="typeContact" readonly
              type="radio" name="inlineDefaultRadiosExample"
              id="defaultInline1" class="custom-control-input"
              value="1">
            </input>
            <label class="custom-control-label" for="defaultInline1">
              {{ $t('common.indiv') }}
            </label>
          </div>
          <div class="custom-control custom-radio custom-control-inline" v-else-if="typeContact === '2'">
            <input v-model="typeContact" readonly
              type="radio" name="inlineDefaultRadiosExample"
              id="defaultInline2" class="custom-control-input"
              value="2">
            </input>
            <label class="custom-control-label" for="defaultInline2">
              {{ $t('common.cmpny_accnt') }}
            </label>
          </div>
        </div>

        <b-row class="form-group">
          <b-col sm="5" class="mb-3">
            <form-read-group-label-input
              :inputLabel="$t('common.nme')" :inputValue="username ? username : '-'">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.als')" :inputValue="label ? label : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="group typeInd" v-if="this.$settings.currentContact.typeContact === '1'">
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.eml')" :inputValue="identifier ? identifier : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group typeCom" v-if="this.$settings.currentContact.typeContact === '2'">
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.srn')" :inputValue="identifier ? identifier : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <b-row class="justify-content-center">
        <b-col sm="11">
          <hr class="w-100"/>
        </b-col>
      </b-row>

      <!-- DDE - 15/03 - plus besoin d'afficher les infos bancaires du contact -->
      <!-- <b-row class="mx-5 mb-4 form-group font-weight-bold">
        <b-col sm="5"
          v-for="bankData in extractedBankData" :key="bankData.labelId">
          <form-read-group-label-input
            :inputLabel="$t(bankData.labelId)" :inputValue="bankData ? bankData : '-'.value">
          </form-read-group-label-input>
        </b-col>
      </b-row> -->

      <!-- 28/02 DDE ajout champs adresse SRTP -->
      <form-accordion :title="$t('common.srtp_adress')" class="form-accordion-subtitle" :isTitleUpperCase="false">
        <b-row class="form-group">
          <b-col sm="5" class="mb-3">
            <form-read-group-label-input
              :inputLabel="$t('contacts.ibn')" :inputValue="iban ? iban : '-'">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.recipient_srtp_id_provider')" :inputValue="idProvider ? idProvider : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <!-- <b-col sm="5" class="mb-3">
            <form-read-group-label-input
              :inputLabel="$t('common.id_contact')" :inputValue="idCompany ? idCompany : '-'">
            </form-read-group-label-input>
          </b-col> -->
          <b-col sm="5" class="mb-3" v-if="this.$engine.user.currentService.id === '2'">
            <form-read-group-label-input
              :inputLabel="$t('bank_accounts.mandat_id')" :inputValue="''"> ? ''"> : '-'
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group" v-if="this.$engine.user.currentService.id === '2'">
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('bank_accounts.mandat_date')" :inputValue="''"> ? ''"> : '-'
            </form-read-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <b-row class="justify-content-center">
        <b-col sm="11">
          <hr class="w-100"/>
        </b-col>
      </b-row>

      <form-accordion :title="$t('common.formsSubTitle.extra_info')" class="form-accordion-subtitle" :isTitleUpperCase="false">
        <b-row class="form-group">
          <b-col sm="5" class="mb-3">
            <form-read-group-label-input
              :inputLabel="$t('common.phn_nbr')" :inputValue="phoneNumber ? phoneNumber : '-'">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.adrs')" :inputValue="address ? address : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>

        <b-row class="form-group">
          <b-col sm="5" class="mb-3">
            <form-read-group-label-input
              :inputLabel="$t('common.cty')" :inputValue="city ? city : '-'">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.zp_code')" :inputValue="zipCode ? zipCode : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>

        <b-row class="form-group">
          <b-col sm="5" class="mb-3">
            <form-read-group-label-input
              :inputLabel="$t('common.cntry')" :inputValue="country ? country : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <b-row xl="12" class="form-group justify-content-end no-gutters" v-if="hasRight('contact_editer')">
        <b-button variant="primary" size="sm" class="mr-3 pt-2"
          href="/account/editContact/">
          <span>
            {{ $t('contacts.edit_contact') }}
          </span>
        </b-button>
        <b-button variant="primary" size="sm" class="mr-3" v-if="hasRight('contact_supprimer')"
          :title="$t('common.rm_label')"
          @click="removeContact">
          <span>
            {{ $t('contacts.supp_contact') }}
          </span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from '@/components/common/backButton.vue'

import {extractForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      iban: '',
      id: '',
      identifier: '',
      idCompany: '',
      idProvider: '',
      username: '',
      extractedBankData: {},
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '',
      zone: '',
      accountLabel: {},
      canEditContact: false,
      canRemoveContact: false,
      returnUrl: '/contacts/'
    }
  },
  created () {
    this.id = this.$settings.currentContact.id
    this.username = this.$settings.currentContact.name
    this.identifier = this.$settings.currentContact.identifier
    this.label = this.$settings.currentContact.label
    this.phoneNumber = this.$settings.currentContact.phoneNumber
    this.typeContact = this.$settings.currentContact.typeContact
    this.address = this.$settings.currentContact.address
    this.city = this.$settings.currentContact.city
    this.zipCode = this.$settings.currentContact.zipCode
    this.country = this.$settings.currentContact.country
    this.zone = this.$settings.currentContact.zoneCode
    this.iban = this.$settings.currentContact.iban
    this.idCompany = this.$settings.currentContact.idCompany
    this.idProvider = this.$settings.currentContact.idProvider
    this.accountLabel = this.$engine.bankAccounts.getAccountLabel(this.zone)

    if (this.$settings.currentContact.iban !== '' && this.zone !== '') {
      this.extractedBankData = extractForeignIban(this.$settings.currentContact.iban, this.zone)
    }
    let that = this
    if (that.$engine.user.get().id === that.$engine.user.get().userAccountId) {
      if (this.$engine.rights.rightIs('contact_editer', true)) {
        that.canEditContact = true
      }
      if (this.$engine.rights.rightIs('contact_supprimer', true)) {
        that.canRemoveContact = true
      }
    }
  },
  methods: {
    hasRight(right) {
      return this.$engine.rights.rightIs(right, true)
    },
    removeContact () {
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('common.oper_confirm'),
        text: this.$i18n.t('contacts.contact_deletion_confirm'),
        buttons: [{
          text: that.$t('common.cncl'),
          onClick: function () {
            // that.$f7.closeModal()
          }
        }, {
          text: 'OK',
          onClick: function () {
            that.$engine.contacts
            .delete(that.$settings.currentContact.id)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('contacts.cntcts_dltd'),
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.identifier = ''
                that.username = ''
                that.$f7.closeModal()
                that.$bus.$emit('refresh-cache-contacts')
                loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
              }, 2000)
            })
            .catch(err => {
              this.handleError(err) // mixins errorHandlerMixins
            })
          }
        }]
      })
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('email')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
        } else {
          that.Dom7($event.target).next().hide()
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
        } else {
          that.Dom7($event.target).parent().next().hide()
        }
      }
    }
  }
}
</script>
